import * as React from "react";
import "./OfferTicket.scss";
import {Business, LocationOffer, UserCard} from "../../../types/Types";
import QRCode from "react-qr-code";
import {QR_CODE_URL} from "../../../utils/Constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock} from "@fortawesome/free-solid-svg-icons";
import {convertTimestampToDate} from "../../../utils/Utils";

interface Props {
  offer: LocationOffer,
  business: Business,
  pointsCard: UserCard,
}

function OfferReceipt(props: Props) {
  return (
      <div>
        <div className="rip"></div>
        <div className={"offer-receipt"}>
            <div className={"offer-qr-code"}>
                <div className={"font-xl font-bold centre-align"}>{props.business.name.toUpperCase()}</div>
                <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={QR_CODE_URL + "/offer/" + props.offer.id + "-" + props.pointsCard.id}
                    viewBox={`0 0 256 256`}
                    fgColor={"#1f1f1f"}
                    bgColor={"#f1f1f1"}
                />
              {props.offer.expiresAt && <div className={"mt-2 font-lg centre-align"}>
                    <div className={"d-inline-block font-sm1 font-black"}>
                        <span className={"font-weight-600"}>EXPIRES: </span>
                        <span className={"font-weight-600"}>{convertTimestampToDate(props.offer.expiresAt).toUpperCase()}</span>
                    </div>
                </div>}
              {!props.offer.expiresAt && <div className={"mt-3"}>
              </div>}
            </div>
        </div>
      </div>
  )
}

export default OfferReceipt;